import { FunctionComponent } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import BasicLink from "@components/core/links/BasicLink";

interface LinkObject {
  title: string;
  link: string;
}

interface FooterProps {
  className?: string;
}

const Footer: FunctionComponent<FooterProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  const linkList: LinkObject[] = [
    {
      title: t("footer.faq"),
      link: "https://assistance.jesignexpert.com/",
    },
    {
      title: t("footer.cgu"),
      link: "https://ressources.ecma-solutions.com/plezi_file/647ef429d59cbc0739f30024/cgu_jesignexpert.com.pdf",
    },
    {
      title: t("footer.rgpd"),
      link: "https://www.universign.com/fr/certifications/",
    },
  ];

  const link = (link: LinkObject, index: number, separator = false) => (
    <div key={`Footer_link_${index}`}>
      <BasicLink
        className="not-underline-by-default"
        to={link.link}
        title={link.title}
      >
        {link.title}
      </BasicLink>
      {separator && <span className="separator">|</span>}
    </div>
  );

  return (
    <footer className={className}>
      <section className="footer-container">
        <div className="logo-container footer-margin-item">
          <img
            alt={t("footer.logo.alt")}
            className="logo"
            src="/img/logo.svg"
          />
          <span className="copyright">© {DateTime.now().year}</span>
        </div>
        <div className="link-container">
          {linkList.map((item, index) =>
            link(item, index, index + 1 !== linkList.length),
          )}
        </div>
        <div className="footer-margin-item" />
      </section>
    </footer>
  );
};

export default Footer;
